/**
 * Wholesale form — conditional field reveals.
 *
 * Drives the "Account type (conditional)" block in sections/wholesale-form.liquid:
 *   - selecting the "Other" option reveals a free-text "please specify" field
 *   - selecting the "Grocery Store" option reveals a department dropdown,
 *     whose own "Other" option reveals a further "please specify" field
 *
 * Visibility is toggled with the native `hidden` attribute. Trigger values are
 * read from data attributes so the block stays editable from the theme editor.
 */
(function () {
  'use strict';

  function syncBlock(block) {
    var main = block.querySelector('[data-account-main]');
    if (!main) return;

    var otherValue = block.getAttribute('data-other-value') || 'Other';
    var groceryValue = block.getAttribute('data-grocery-value') || 'Grocery Store';
    var otherGroup = block.querySelector('[data-account-other]');
    var groceryGroup = block.querySelector('[data-account-grocery]');
    var dept = block.querySelector('[data-grocery-dept]');
    var deptOtherGroup = block.querySelector('[data-grocery-other]');

    function syncDept() {
      if (!dept || !deptOtherGroup) return;
      var deptOtherValue = dept.getAttribute('data-other-value') || 'Other';
      var groceryShown = groceryGroup && !groceryGroup.hidden;
      deptOtherGroup.hidden = !(groceryShown && dept.value === deptOtherValue);
    }

    function update() {
      if (otherGroup) otherGroup.hidden = main.value !== otherValue;
      if (groceryGroup) groceryGroup.hidden = main.value !== groceryValue;
      syncDept();
    }

    if (!main.dataset.wmBound) {
      main.addEventListener('change', update);
      if (dept) dept.addEventListener('change', syncDept);
      main.dataset.wmBound = '1';
    }

    update();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-account-type]').forEach(syncBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-initialise when the section is (re)rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
